// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__JJz3H","dropdown-menu":"Navbar_dropdown-menu__wpSpG"};